import { render, staticRenderFns } from "./contract-base.vue?vue&type=template&id=1a4a5621&"
import script from "./contract-base.vue?vue&type=script&lang=ts&"
export * from "./contract-base.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports